import { Box, Text, TextButton, TextProps } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials-standalone/i18n';

interface TemplateGalleryEmptyFooterProps {
  className?: string;
  textProps?: Pick<TextProps, 'size' | 'weight'>;
}

const TemplateGalleryEmptyFooter = ({
  className,
  textProps = {},
}: TemplateGalleryEmptyFooterProps) => {
  const { t } = useTranslation();
  const onClickBrowseWixTemplates = () => {};

  return (
    <Box marginTop="42px" className={className}>
      <Trans i18nKey="marketplace.templates-page.empty-state-gallery-footer.browse-wix-templates-cta">
        <Text {...textProps}>
          0
          <TextButton
            {...textProps}
            onClick={onClickBrowseWixTemplates}
            as="a"
            href={t(
              'marketplace.templates-page.empty-state.gallery-footer.browse-wix-templates-link',
            )}
            target="_blank"
          >
            1
          </TextButton>
        </Text>
      </Trans>
    </Box>
  );
};

export default TemplateGalleryEmptyFooter;
